export const validatePhoneNumber = (phoneNumber) => {
    var regex = /^1[3-9]\d{9}$/;
    return regex.test(phoneNumber);
}